var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_3_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_3_2_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M465.3,325.7c-1.2-2.3-1.9-4.6-2.5-7c-5.4-20.6-9.3-43.2-9.4-63.4c0.1-0.1,0.2-0.3,0-0.1 c-5.6,8.5-4.7,26.4-5.5,35.9c-1,10.5-3.3,17.6-10.1,25.7c-7.1,8.6-12.7,13.1-14.8,23.9c-0.6,3.1-0.9,12.5-5.1,13.4 c-5.2,1.1-6.7-8.2-8.4-11.3c-4.3-7.5-14-15.1-22.6-13.8c-4.6,0.7-9,4.5-13.3,5.9c-8.7,3.4-19.2,1.7-26.7-1 c-4.3-1.5-8-3.1-12.5-3.7c-8.7-1.3-19.3,7.4-23.6,14.9c-1.8,3.1-3.4,10-8.6,9c-4.1-0.8-4.5-10.3-5.1-13.4 c-2.1-10.8-7.7-15.3-14.8-23.9c-6.8-8.2-9.1-15.2-10.1-25.7c-0.9-9.5-0.5-30.1-6.2-38.6c-0.1,20.2-3.9,42.4-9.3,63 c-0.6,2.4-2,8.9-3.2,11.2c2.9-1.4,7.7-4.8,9.6-8c-0.9,8.7-3.4,14.9-6.4,22.9c2.9,0.4,5.7-1.8,8-2.9c1.5,6.9-1.4,18.5-3.4,24.9 c3.7,0.1,9.4-2.3,10.2-5.7c0.1,5.7-0.3,10.6-1.3,16c4.2,0.3,10.4-3.2,11.5-7.1c2.6,6.6,3.7,10.6,5.7,18.4c1.2,4.7,0.3,4.9,4.6,2.4 c2.2-1.2,4.7-5.8,5.7-8.1c2.8,7.8,9.5,8.9,13.5,11.7c-4.6-15.2,5.7-47.1,26.6-50.1c8.7-1.3,10.4-1,20.5-0.9l0,0c0.5,0,1,0,1.5,0 c0.6,0,1.1,0,1.8,0l0,0c10.7-0.1,17-0.6,25.8,0.7c20.9,3.1,27.3,34.1,22.7,49.3c3.9-2.8,9.2-2.8,12.1-10.6c1,2.3,3.5,6.8,5.7,8.1 c4.3,2.5,2.9,2.1,4.6-2.4c2.3-6.2,3.9-12.4,5.7-18.4c1.1,3.8,7.3,7.4,11.5,7.1c-0.9-5.4-1.4-10.3-1.3-16c0.8,3.3,6.6,5.8,10.2,5.7 c-2-6.5-5-15.3-3.5-22.2c2.3,1.1,4.8,2.4,7.7,2c-2.9-7.9-6.2-15.2-7.1-23.9C457.8,322.7,462.4,324.3,465.3,325.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M266.2,252.6C265.5,249.9,265.9,252.2,266.2,252.6L266.2,252.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard3D);
export default __webpack_public_path__ + "static/media/man_beard_3d.3c189f5a6973569b6555e7ca52fc9dba.svg";
export { ForwardRef as ReactComponent };